<template>
  <div class="pro-item" v-if="safeItem" @click="$router.push(
        {
          name: 'product',
          query: {
            id: safeItem.id
          }
        },
        () => {}
      )">
    <div class="pro-state">{{ safeItem.status_text }}</div>
    <img v-lazy="safeItem.logo" :alt="safeItem.name" class="pro-img" />
    <div class="item-content">
      <p class="no">
        No. : <span>{{ safeItem.id }}</span>
      </p>
      <h3 class="van-ellipsis">{{ safeItem.name }}</h3>
      <p class="van-multi-ellipsis--l2" v-html="safeItem.bewrite"></p>
      <p class="price">
        ￥<span>{{ safeItem.starting_price }}</span>
      </p>
    </div>
    <div class="btns" style="display: none;">
      <van-button
        type="warning"
        style="flex: 1"
        size="small"
        @click="toProEdit()"
        >编辑</van-button
      >
      <van-button
        type="danger"
        style="flex: 1"
        size="small"
        @click="toProDelete()"
        >删除</van-button
      >
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  name: 'MyHomeProductView',
  props: ['item'],
  computed: {
    safeItem () {
      return this.item || null
    }
  },
  methods: {
    toProEdit () {
      if (this.safeItem.status == 2) {
        Dialog.alert({
          title: '提示',
          message: '已出售商品不可编辑'
        })
        return
      }
      this.$router.push(
        {
          name: 'shoppro',
          query: {
            id: this.safeItem.id
          }
        },
        () => {}
      )
    },
    async toProDelete () {
      if (this.safeItem.status == 2) {
        Dialog.alert({
          title: '提示',
          message: '已出售商品不可删除'
        })
        return
      }
      Dialog.confirm({
        title: '提示',
        message: '是否删除该商品？'
      })
        .then(async () => {
          await this.$http({
            method: 'post',
            url: 'deleteShopProduct',
            data: { id: this.safeItem.id }
          }).then(res => {
            this.$toast.success(res.msg)
            this.$emit('refresh-data')
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.pro-item {
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  .pro-state {
    background: rgba(0, 0, 0, 0.65);
    height: 32px;
    line-height: 32px;
    padding: 0px 10px;
    color: #fff;
    font-size: 14px;
  }
  img.pro-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
  }
  .item-content {
    padding: 10px;
    p.no {
      color: #000;
      font-size: 12px;
      font-weight: 600;
      span {
        font-size: 15px;
      }
    }
    p.price {
      color: #000;
      font-size: 13px;
      span {
        font-size: 16px;
        font-weight: 550;
      }
    }

    h3 {
      font-size: 18px;
      margin-bottom: 8px;
      color: #000;
    }

    p {
      color: #646566;
      font-size: 14px;
      line-height: 1.6;
    }
  }
  .btns {
    display: flex;
    gap: 8px;
    margin: 6px;
  }
}
</style>
